import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=979cf6cc&"
import script from "./youtube-video.vue?vue&type=script&lang=js&"
export * from "./youtube-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('979cf6cc')) {
      api.createRecord('979cf6cc', component.options)
    } else {
      api.reload('979cf6cc', component.options)
    }
    module.hot.accept("./youtube-video.vue?vue&type=template&id=979cf6cc&", function () {
      api.rerender('979cf6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dfpK4DzfU6f6/JS/youtube-video.vue"
export default component.exports